import {useTranslation} from 'react-i18next';

import {Box, Grid} from '@mui/material';

import {EmpionButton} from '../../../../../../../components/EmpionButton/EmpionButton';
import {FORM_MODE_CREATE, FORM_MODE_EDIT} from '../../../../../../../lib/constants';

interface JobPostingFormMenuProps {
  mode: string;
  jobPostingPublished: boolean;
  formik: any;
  onCancel(): void;
  onPublish(resourceId: string): void;
  setSaveAndPublish(value: boolean): void;
  jobPostingResourceId: string;
  assignAdmins(value: boolean): void;
}

export const JobPostingFormMenu = ({
  mode,
  jobPostingPublished,
  formik,
  onCancel,
  onPublish,
  setSaveAndPublish,
  jobPostingResourceId,
  assignAdmins,
}: JobPostingFormMenuProps) => {
  const {t} = useTranslation();

  const onClick = () => {
    if (mode === FORM_MODE_CREATE) {
      setSaveAndPublish(true);
      formik.submitForm();
    } else {
      onPublish(jobPostingResourceId);
    }
  };

  return (
    <Box
      sx={{
        padding: '16px',
        borderRadius: '16px',
        backgroundColor: 'background.dark',
        width: '100%',
        sticky: 'bottom',
      }}
    >
      <Grid container display={'flex'} spacing={2} alignItems={'center'}>
        <Grid item xs={12} md={3}>
          <EmpionButton onClick={onCancel} color='primary' fullWidth>
            {mode === FORM_MODE_CREATE ? t('shared.formButtons.discard') : t('shared.formButtons.close')}
          </EmpionButton>
        </Grid>
        <Grid item xs={12} md={3}>
          <EmpionButton type='submit' disabled={formik.isSubmitting || !formik.dirty} fullWidth>
            {t('shared.formButtons.save')}
          </EmpionButton>
        </Grid>
        <Grid item xs={12} md={3}>
          <EmpionButton
            fullWidth
            onClick={() => {
              assignAdmins(true);
            }}
          >
            {t('shared.formButtons.assign')}
          </EmpionButton>
        </Grid>
        <Grid item xs={12} md={3}>
          <EmpionButton
            onClick={onClick}
            disabled={
              formik.isSubmitting ||
              !formik.dirty ||
              jobPostingPublished ||
              (mode !== FORM_MODE_CREATE && mode !== FORM_MODE_EDIT)
            }
            fullWidth
          >
            {mode === FORM_MODE_CREATE
              ? t('shared.formButtons.saveAndPublish')
              : jobPostingPublished
                ? t('shared.published')
                : t('shared.formButtons.publish')}
          </EmpionButton>
        </Grid>
      </Grid>
    </Box>
  );
};
